import { render, staticRenderFns } from "./ImageButton.vue?vue&type=template&id=23b48cd2&scoped=true&"
import script from "./ImageButton.vue?vue&type=script&lang=js&"
export * from "./ImageButton.vue?vue&type=script&lang=js&"
import style0 from "./ImageButton.vue?vue&type=style&index=0&id=23b48cd2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23b48cd2",
  null
  
)

export default component.exports